
















import {Component, Prop, Vue, Watch} from "vue-property-decorator";

@Component({
    components: {},
})
export default class UserAvatar extends Vue {
    @Prop() user!: any;
    @Prop() tag !: string;

    picture = ''

    async mounted() {
        await this.$store.dispatch("loginState");
        if (this.user) {

            this.picture = this.user.picture ? this.user.picture + `?t=${Date.now()}` : '/img/300_300_default_profile.png'
        }else{
            this.picture = '/img/300_300_default_profile.png'
        }
    }

    moveUserPage() {
        if(this.user.channel_id)
        this.$router.push(`/${this.$i18n.locale}/channel/${this.user.channel_id}/timeline`)
    }
}
